export default "__VITE_ASSET__d8fe5544__"